export default "__VITE_ASSET__DhchqP5M__"